module.exports = __webpack_public_path__ + "img/android-screen.ae370fc9.png";